export const environment = {
  production: true,
  // rootUrl : 'http://localhost:57388/',
  // rootUrl : 'https://apiadmin-uat.garage.sa/',
  
  rootUrl : 'https://api-admin.garage.sa/',
  //rootUrl : 'https://admin-api-v1-bybbdubrc2ccayfe.uaenorth-01.azurewebsites.net/',  
  // rootUrl : 'https://apiadmin-uat.azurewebsites.net/',
  rootScope:null,
  LocationID: 0,
  LocationSelected: null,
  Language: "en",
  dir: "ltr",
  Currency: "SAR",
  IsOdoo: false,
  OdooApiKey: '',
  OdooFunctionsUrl: 'https://functions.karage.co/api',
};

